import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { adminCheckSession, adminLogout, listPrograms, setAdminToken } from './adminApi';
import './admin.css';

function AdminProgramList() {
  const navigate = useNavigate();
  const [programs, setPrograms] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        await adminCheckSession();
        const data = await listPrograms();
        if (!cancelled) setPrograms(data.data || []);
      } catch (err) {
        if (err.status === 401) {
          setAdminToken('');
          navigate('/admin/login', { replace: true });
          return;
        }
        if (!cancelled) setError(err.message || 'Failed to load programs');
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [navigate]);

  const handleLogout = async () => {
    await adminLogout();
    navigate('/admin/login', { replace: true });
  };

  return (
    <div className="admin-page">
      <div className="admin-topbar">
        <h1 className="admin-title">Manual programs</h1>
        <div className="admin-topbar__actions">
          <Link to="/admin/programs/new" className="admin-btn admin-btn--primary">
            New program
          </Link>
          <button type="button" className="admin-btn" onClick={handleLogout}>
            Log out
          </button>
        </div>
      </div>

      {loading && <p className="admin-muted">Loading…</p>}
      {error && <p className="admin-error">{error}</p>}

      {!loading && !error && programs.length === 0 && (
        <p className="admin-muted">No programs yet. Create one to get started.</p>
      )}

      {programs.length > 0 && (
        <div className="admin-table-wrap">
          <table className="admin-table">
            <thead>
              <tr>
                <th>Title</th>
                <th>Status</th>
                <th>Shows</th>
                <th>Updated</th>
              </tr>
            </thead>
            <tbody>
              {programs.map((program) => (
                <tr key={program.id}>
                  <td>
                    <Link to={`/admin/programs/${encodeURIComponent(program.id)}`}>
                      {program.title || program.id}
                    </Link>
                  </td>
                  <td>
                    <span className={`admin-status admin-status--${program.status || 'draft'}`}>
                      {program.status || 'draft'}
                    </span>
                  </td>
                  <td>{program.occurrence_count}</td>
                  <td>{program.updated_at ? new Date(program.updated_at).toLocaleString() : '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default AdminProgramList;
